const state = {
  dialog: false,
  title: null,
  message: null,
  price: null
}
const mutations = {
  SHOW_DIALOG: (state, payload) => {
    state.dialog = true;
    state.title = payload.title;
    state.message = payload.message
    state.price = payload.price
  },
  HIDE_DIALOG: (state) => {
    state.dialog = false;
  }
}
const actions = {
  showDialog: (context, payload) => {
    context.commit("SHOW_DIALOG", payload);
  },
  hideDialog: (context) => {
    context.commit("HIDE_DIALOG");
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}